import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelcase'
})
export class CamelcasePipe implements PipeTransform {

  transform(value: string): string {
    return value
      ?.replace(/\s(.)/g, char => char?.toUpperCase())
      ?.replace(/\s/g, '')
      ?.replace(/^(.)/, char => char?.toLowerCase());
  }

}
